/** @jsx jsx */
/** @jsxFrag React.Fragment */
// @ts-check
import { Badge, Box } from '@bottlebooks/gatsby-theme-base/src';
import { jsx } from 'theme-ui';

export default function ProductStandBadge({ standName, ...rest }) {
  return (
    <Box {...rest}>
      <Badge sx={{ backgroundColor: 'primary', color: 'white' }}>
        {standName}
      </Badge>
    </Box>
  );
}
